export const airbagKey = 'airbag';
export const bodyTypeKey = 'bodyType';
export const cameraKey = 'camera';
export const climateKey = 'climate';
export const colorInteriorKey = 'colorInterior';
export const vehicleColorKey = 'vehicleColor';
export const vehicleColorTypeKey = 'vehicleColorType';
export const cruiseKey = 'cruise';
export const driveunitKey = 'driveunit';
export const fuelKey = 'fuel';
export const ownersKey = 'owners';
export const powerSteeringKey = 'powerSteering';
export const registrationKey = 'registration';
export const seatsHeatKey = 'seatsHeat';
export const seatsTypeKey = 'seatsType';
export const transmissionKey = 'transmission';
export const vehicleExchangeKey = 'vehicleExchange';
export const clearVehicleKey = 'clearVehicle';

// images
export const imageUploadKey = 'imageUpload';
export const deleteImageKey = 'deleteImage';
export const deleteImagesKey = 'deleteImages';
export const getImagesKey = 'getImages';
